<template>
  <div>

    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
            <h1>
             <i class="el-icon-s-order"></i>
             Log de cambios
            </h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <!-- Table Logs -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card class="box-card">

          <!-- <div slot="header" style="text-align: right;" >
            <el-date-picker
              v-model="date"
              type="daterange"
              align="right"
              start-placeholder="Start Date"
              end-placeholder="End Date"
              default-value="2020-03-01">
            </el-date-picker>
          </div> -->

          <div slot="header" style="text-align: right;" >
            <el-radio-group
              v-model="type"
              size="mini"
              @change="update">
              <el-radio-button label="diff">General</el-radio-button>
              <el-radio-button label="snapshot">Distribuciones</el-radio-button>
            </el-radio-group>
          </div>

          <el-row>
            <el-col :span="6">
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in logs"
                  :key="index"
                  color="#0bbd87"
                  :timestamp="activity.created_at | formatDate">
                  <el-tag size="mini" effect="plain" type="success">{{index + 1}}</el-tag>
                  <el-link
                    @click="handleView(activity)">
                    {{getValue(activity ,'user','name')}}
                    <i class="el-icon-view el-icon--right"></i>
                  </el-link>
                </el-timeline-item>
              </el-timeline>
            </el-col>
            <el-col :span="18">
              <div v-if="data">
                <el-tag
                  type="danger"
                  effect="plain">
                   {{data.activity.created_at | formatDate}}
                </el-tag>

                 <el-tag
                  type="primary"
                  effect="plain">
                  {{data.activity.user.name}}
                </el-tag>

                <el-tag
                  type="success"
                  effect="plain">
                    {{data.activity.user.email}}
                </el-tag>

                <div v-if="type == 'diff'">
                  <pre v-html="$options.filters.convertToHtml(data.diff)"></pre>
                </div>

                <div v-if="type == 'snapshot'">
                  <pre v-html="$options.filters.prettyAreaData(data.diff)"></pre>
                </div>

              </div>
            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>
    <!-- END Table Logs -->
    <br>
  </div>
</template>

<script>
import getValue from '@/utils/getValue';
// eslint-disable-next-line import/no-cycle
import http from '@/utils/http';

export default {
  name: 'Log',
  components: {
  },
  data() {
    return {
      type: 'diff',
      date: '',
      logs: [],
      data: null,
    };
  },
  methods: {

    getValue(obj, level, ...rest) {
      return getValue(obj, level, ...rest);
    },

    async update() {
      try {
        const { data } = await http.get(`/changelog?type=${this.type}`);
        this.logs = data;
      } catch (error) {
        console.log(error.response);
        this.$message({
          message: error,
          type: 'error',
          duration: 8000,
        });
      }
    },
    async handleView(activity) {
      try {
        // eslint-disable-next-line no-underscore-dangle
        const { data } = await http.get(`/changelog/${activity._id}`);
        this.data = { activity, diff: data.diff };
      } catch (error) {
        console.log(error.response);
        this.$message({
          message: error,
          type: 'error',
          duration: 8000,
        });
      }
    },
  },
  async mounted() {
    await this.update();
  },
};

</script>

<style scoped>

  .el-tag{
    margin:0px 10px;
  }

  .el-button--text {
    padding: 3px 25px;
  }

  .el-timeline {
    overflow-y: auto;
    height: 100vh;
    padding-top: 20px;
  }

  pre {
    margin: 10px;
    overflow-y: auto;
    height: 100vh;
    padding-top: 20px;
  }

</style>
